module.exports = __webpack_public_path__ + "img/estimates_image_page_x2.122bc0e4.png";